import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { AppConfigService as appConfig } from '@app/app.config';
import { FINANCIAL_PRODUCTS_BASE_PATH, OPERATION_BASE_PATH, VENDOR_DATA_BASE_PATH } from '@app/shared/constants/communications';

import * as appData from '../assets/json/appData.json';

import * as financialProducts from '../assets/json/financial-products.json';
import { FinancialProducts } from './shared/interfaces/financial-simulator/financial-products.interface';
import { FinancialProductRequest } from './shared/interfaces/financial-simulator/financial-product-request.interface';

import { VehicleData } from './shared/interfaces/data/vehicle-data.interface';
import { Data } from './shared/interfaces/data/data.interface';
import { Operation } from './shared/models/subscription';
/*
import { HttpServiceI } from '@csi/angular-core/src/lib/http';
 */

@Injectable({
    providedIn: 'root',
})
export class AppService {
    data2 = appData;
    //financialProducts: FinancialProducts = JSON.parse(financialProducts);
    financialProducts = financialProducts;

    private today = new Date();

    data : Data = {
        userData: {
            idNumber: undefined,
            order: undefined,
            privacySettings: {
                switchPrivacy1: '',
                switchPrivacy2: '',
                switchPrivacy3: '',
                switchPrivacy4: '',
            },
            coHolder: {
                key: '',
            },
            identification: {
                dni: '',
                expirationNif: new Date()
            },
            personalDataInfo: {
                gender: '',
                textFirst: '',
                textName: '',
                textSecond: '',
            },
            additionalDataFirst: {
                maritalStatus: '',
                childrenNumber: ''
            },
            additionalDataSecond: {
                year: '',
            },
            additionalDataLoan: {
                loanSituation: false,  // Pendiente mapeo
                cost: null
            },
            houseType: {
                typeHousingContract: 'P',
                year: '',
                cost: null,
            },
            houseAddress: {
                streetType: {code : '', name : ''},
                streetName: '',
                streetNumber: '',
                streetAdditionalInfo: '',
                city: '',
                postalCode: '',
                province: { code: '', name: '' },
            },
            personalDataBirth: {
                country: { code: '', name: '', regime: '' },
                birthDate: new Date(this.today.getFullYear() - 18, this.today.getMonth(), this.today.getDay())
            },
            contactDataInfo: {
                email: '',
                telephone: ''
            },
            contractType: {
                workContractType: '',
                stableWorkingStartDate: new Date(),
                temporaryWorkingStartDate: null,
                temporaryWorkingEndDate: null,
                monthlyNetIncome: null,
            },

            coOperator: {
                coOperatorRadioButton: false,
            },
            bankDetails: {
                iban: '',
            },
            authenticationData: {
                auth: false,
            },
            recruitment: {
                recruit: false,
            },
            documentation: {
                upload1: null,
                upload2: null,
            },

            workingSituation: {
                workStatus: undefined,
                workingSituationTitle: '',
                workingSituationSubtitle: '',
                companyName: '',
                sectorText: '',
                branchText: '',
                professionText: '',
                //no working
                situationText: '',
                monthlyNetIncomeLabel: '',
                revenue: undefined,
                lastJobText: '',
                notWorkingSituation: null,
                profession: undefined,
                branch: undefined,
                sector: undefined,
                company: '',
                laborSeniority: null
            },
            vendor: '',
            salesman: '',
            store: '',
            partner: '',
            agreement: '',
        },
        vehicleData: {
            type: '',
            brand: '',
            model: '',
            version: '',
            price: 0,
            vin: '',
            modelYear: 0,
            mileage: 0,
            annualMileage: 0,
            plateNumber: '0000BCD',
            firstRegistrationDate: ''
        },
        financialData: {
            channel: '',
            secureCode: '',
            price: 0,
            currencyCode: '',
            nominalRate: 0,
            aprcRate: 0,
            amountFinanced: 0,
            totalInterestGrossAmount: 0,
            totalCreditCost: 0,
            totalCreditCostInsurance: 0,
            totalAmountDue: 0,
            totalAmountDueInsurance: 0,
            installmentTotalGrossAmount: 0,
            installmentTotalGrossAmountInsurance: 0,
            installmentFirstGrossAmount: 0,
            installmentLastGrossAmount: 0,
            installmentMonthlyGrossAmount: 0,
            financedAndInsuranceTotalGrossAmount: 0,
            vat: 0,
            paymentProtectionInsurance: false,
            financialProduct: {
                id: '',
                name: ''
            },
            formalizationFee: {
                type: '',
                amount: 0,
                percentage: 0
            },
            financialProducts: null,
            duration: '',
            downPaymentGrossAmount: 0,
            annualMileages: 0,
            installmentAndInsuranceTotalGrossAmount: 0,
            installmentAndInsuranceFirstGrossAmount: 0,
            installmentAndInsuranceLastGrossAmount: 0,
            residualValue: null,
            secureCost: null,
            promotion: null,
            material: null,
            arrangementFeeCode: null,
            deferralType: null
        },
        operationData : {
            subscriptionId: null,
            completeSubscriptionWebUrl: '',
            publicId: '',
            score: {
                operationScore: {
                    requiredDocuments : null,
                    subscriptionScore : null
                }
            }
        }
    }

    private http = inject(HttpClient);
    private appConfig = inject(appConfig);

    constructor() {}

    //---------------------------//
    //--------SERVICE MOCK-------//
    //---------------------------//

    getVehicleDataMocked(): Observable<VehicleData> {
        return of(this.data2.vehicle);
    }

    getCarFinancialDataMocked(): Observable<any> {
        return of(this.data2.financialData);
    }

    getFinancialProductsMocked(): Observable<any> {
        return of(this.financialProducts.financialProducts);
    }

    //-----------------------//
    //--------SERVICE-------//
    //----------------------//

    getCarFinancingConditions(token: string): Observable<Operation> {
        const CAR_FINANCING_CONDITIONS_URL: string = this.appConfig.apiBffUrl + OPERATION_BASE_PATH + '?token=' + token + '';
        //const CAR_FINANCING_CONDITIONS_URL: string = 'http://localhost:8080'.concat('/api/mobility/operation?token=').concat(token);

        return this.http.get<Operation>(CAR_FINANCING_CONDITIONS_URL).pipe();
    }

    getVendor(salesAgentId: string, partnerStoreIds: string): Observable<any> { //TODO montar estructura vendor?
        const VENDOR_URL: string = this.appConfig.apiBffUrl + VENDOR_DATA_BASE_PATH + '/getVendor?salesAgentId=' + salesAgentId + '&partnerStoreIds=' + partnerStoreIds;
        //const VENDOR_URL: string = 'http://localhost:8080'.concat('/api/mobility/vendor-data/getVendor?salesAgentId=')
        //    .concat(salesAgentId).concat('&partnerStoreIds=').concat(partnerStoreIds);

        return this.http.get<any>(VENDOR_URL).pipe();
    }

    getFinancialProducts(financialProductsRequest: FinancialProductRequest): Observable<any> {
        const FINANCIAL_PRODUCTS_URL: string = this.appConfig.apiBffUrl + FINANCIAL_PRODUCTS_BASE_PATH;
        //const FINANCIAL_PRODUCTS_URL: string = 'http://localhost:8080' + FINANCIAL_PRODUCTS_BASE_PATH;

        return this.http.post<FinancialProducts>(FINANCIAL_PRODUCTS_URL, financialProductsRequest).pipe();
    }
    /*
    getCarFinancingConditions(token:string): Observable<CarFinancingConditions> {
        return this.http.get<CarFinancingConditions>(this.url_api + 'operation?token=' + token + '');
    }

    getFinancialProducts(financialProductsRequest: FinancialProductRequest): Observable<any> {
        return this.http.post<any>(this.url_api + 'financial-products', financialProductsRequest);
    }
 */
}
